import React, { useState } from "react";

interface LoginPageProps {
  onLoginSuccess: () => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLoginSuccess }) => {
  const [step, setStep] = useState<"login" | "otp">("login");
  const [mobileNumber, setMobileNumber] = useState<string>("");
  const [otp, setOtp] = useState<string[]>(Array(6).fill(""));
  const [error, setError] = useState<string>("");

  const fixedMobileNumber = "999999888";
  const fixedOtp = "678901";

  const handleMobileNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    if (value.length <= 10) {
      setMobileNumber(value);
    }
  };

  const handleOtpChange = (value: string, index: number) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 5) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        nextInput?.focus();
      }
    }
  };

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (mobileNumber === fixedMobileNumber) {
      setError("");
      setStep("otp");
    } else {
      setError("Invalid mobile number");
    }
  };

  const handleOtpVerification = (e: React.FormEvent) => {
    e.preventDefault();
    const enteredOtp = otp.join("");
    if (enteredOtp === fixedOtp) {
      setError("");
      onLoginSuccess();
    } else {
      setError("Invalid OTP");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-gray-100 to-gray-200">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-3xl font-bold text-gray-800 text-center mb-6">
          {step === "login" ? "Welcome Back" : "Verify Your OTP"}
        </h2>
        <p className="text-gray-600 text-center mb-4">
          {step === "login"
            ? "Please enter your mobile number to proceed."
            : "Enter the OTP sent to your mobile number."}
        </p>
        <form
          onSubmit={step === "login" ? handleLogin : handleOtpVerification}
          className="space-y-6"
        >
          {step === "login" ? (
            <div>
              <label
                htmlFor="mobileNumber"
                className="block text-sm font-medium text-gray-700"
              >
                Mobile Number
              </label>
              <div className="flex items-center mt-2">
                <span className="p-3 bg-gray-200 rounded-l-lg text-gray-700 font-semibold">
                  +91
                </span>
                <input
                  type="text"
                  id="mobileNumber"
                  value={mobileNumber}
                  onChange={handleMobileNumberChange}
                  className="flex-1 p-3 border border-gray-300 rounded-r-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  placeholder="Enter your mobile number"
                  maxLength={10}
                />
              </div>
            </div>
          ) : (
            <div>
              <label htmlFor="otp" className="block text-sm font-medium text-gray-700">
                OTP
              </label>
              <div className="flex justify-center gap-2 mt-2">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type="text"
                    value={digit}
                    onChange={(e) => handleOtpChange(e.target.value, index)}
                    className="w-12 h-12 text-center text-xl border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    maxLength={1}
                  />
                ))}
              </div>
            </div>
          )}

          {error && (
            <p className="text-red-500 text-center text-sm mt-2">{error}</p>
          )}

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition duration-300"
          >
            {step === "login" ? "Send OTP" : "Verify OTP"}
          </button>
        </form>
        <p className="text-center text-sm text-gray-600 mt-4">
          Need help? <a href="#" className="text-blue-500">Contact Support</a>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
